<script>
  import Modal from '@components/shared/modal.svelte';
  
  let { absence = $bindable(null), role = "viewer", onUpdate, onDelete } = $props();
  
  let open = $derived(absence !== null );
  let title = $derived(absence ? `Absence: ${absence.user.name}` : null);
  let editable = $derived(absence && (role === "admin" || (role === "manager" && !absence.user.vet)));
  let reason = $state("")
  let period = $state("");
  
  let periodText = $derived.by(() => {
    if (!absence) return "";
    if (absence.period === "am") return "Matin";
    if (absence.period === "pm") return "Après-midi";
    if (absence.period === "day") return "Journée";
    return "";
  });
  
  $effect(() => {
    reason = absence?.reason || "";
    period = absence?.period || "";
  });
  
  function handleUpdate(e) {
    e.preventDefault();
    if (!editable) return;
    onUpdate?.(absence.id, { reason, period });
    absence = null;
  }

  function handleDelete() {
    if (!editable) return;
    const id = absence.id;
    absence = null;
    onDelete?.(id);
  }
</script>

<Modal open={open} onClose={() => absence = null} {title}>

  <form id="absence-form" onsubmit={handleUpdate}>
    
    {#if !editable}
      <div class="app-message notice">
        Ce formulaire est en lecture seule.
      </div>
    {/if}

    <div class="form-items">

      <div class="form-item col-span-6">
        <label for="date">Date</label>
        <input readonly type="text" id="date" value={new Date(absence.date).toLocaleDateString()} />
      </div>

      <div class="form-item col-span-6">
        <label for="period">Période</label>
        <select id="period" bind:value={period} disabled={!editable}>
          {#each absence.available_slots as slot}
            {@const label = slot === "am" ? "Matin" : slot === "pm" ? "Après-midi" : "Journée"  }
            <option value={slot}>{label}</option>
          {/each}
        </select>
      </div>

      <div class="flex items-center relative col-span-12 w-[102%] mx-[-1%]">
        <mark class="p-2 bg-transparent ml-3 text-xs text-gray-500 z-[2]">Autres informations</mark>
        <span class="absolute left-0 bg-gray-200/80 w-full h-px"></span>
      </div>

      <div class="form-item col-span-12">
        <label for="reason">Raison</label>
        <textarea name="reason" id="reason" bind:value={reason} readonly={!editable}></textarea>
      </div>
      
    </div>

  </form>

  {#snippet footerButtons()}
    {#if editable}
      <button type="button" class="button outline-danger" onclick={handleDelete}>Supprimer</button>
      <button class="button submit" form="absence-form">Mettre à jour</button>
    {/if}
  {/snippet}
  
</Modal>
